import React, {useEffect, useRef, useState} from "react";
import {AlbumList} from "../../components/category";
import BannerAlbum from "../../components/home/BannerAlbum"
import axios from "axios";
import LoadingBar from "../../components/common/LoadingBar";

const apiUrl = process.env.REACT_APP_APIGATEWAY_ENDPOINT
const albumCountPerPage = process.env.REACT_APP_PAGINATION_ALBUM_DISPLAY_COUNT

const CategoryPage = ({pageType}) => {
    const didMount = useRef(false);
    const [albumList, setAlbumList] = useState([]);
    const [recommendAlbumList, setRecommendAlbumList] = useState([]);
    const [page, setPage] = useState(1);
    const [pageInfo, setPageInfo] = useState({
        itemsCountPerPage: albumCountPerPage,
        itemCount: 0,
        pageDisplay: 5,
        onPageChange: setPage
    });
    const [sortType, setSortType] = useState(1)
    const [loading, setLoading] = useState(true)
    const changeSort = (sortType) => {
        setSortType(sortType)
    }

    const fetchAllCategoryProducts = () => {
        axios.get(apiUrl + "/product/public/main/list?category=" + pageType + "&page=" + page + "&sortType=" + sortType + "&albumCountPerPage=" + albumCountPerPage)
            .then((res) => {
                // setBannerList( res.data)
                const categories = res.data.albums;
                categories.forEach(e => {
                    switch (e.category) {
                        case Number.parseInt(pageType):
                            setAlbumList(e.albumList);
                            const pageInfo = {
                                activePage: page,
                                itemsCountPerPage: albumCountPerPage,
                                itemCount: e.albumCount,
                                pageDisplay: 5,
                                onPageChange: setPage
                            }
                            setPageInfo(pageInfo)
                            break;
                        default:
                    }
                })
                setRecommendAlbumList(res.data.recommendAlbums)
            })
            .catch(err => {
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        setLoading(true)
        if(page !== 1) {
            setPage(1)
        } else {
            fetchAllCategoryProducts();
        }
    }, [pageType]);

    useEffect(() => {
        if(didMount.current) {
            fetchAllCategoryProducts();
        }
    }, [page]);

    useEffect(() => {
        if(didMount.current) {
            fetchAllCategoryProducts();
        } else {
            didMount.current = true;
        }
    }, [sortType]);

    if(loading) {
        return (
            <div style={{height: '100vh', display: 'block'}}>
                <LoadingBar/>
            </div>
        )
    } else {

        return(
            <>
                {pageType !== '5' && (
                    <BannerAlbum albumList={recommendAlbumList}/>
                )}
                <AlbumList albumList={albumList} pageInfo={pageInfo} changeSort={changeSort} />
            </>
        )
    }
}

export default CategoryPage;